import React, { useState } from "react";
// import "./WhatsAppWidget.css";

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {/* Floating Button */}
      <div className="whatsapp_float" onClick={() => setIsOpen(!isOpen)}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          className="whatsapp_icon"
        />
      </div>

      {/* Popup Chat Box */}
      {isOpen && (
        <div className="whatsapp_popup">
          <div className="whatsapp_header">
            <img
              src="https://i.ibb.co/8gKBxLS9/Javed-1.png"
              alt="JS Contracts"
              className="whatsapp_avatar"
            />
            <div>
              <h4>JS Contracts</h4>
              <p>Typically replies within 5 mins</p>
            </div>
          </div>
          <div className="whatsapp_body">
            <p className="bot_message">
              👋 Hello! How can we help you with painting services?
            </p>
          </div>
          <div className="whatsapp_footer">
            <a
              href="https://wa.me/923007665370?text=Hello%20I%20am%20interested%20in%20your%20painting%20services"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Start Chat</button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppWidget;
